import moment from 'moment';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { decrypt, encrypt } from './crypto';

export const formatTimestamp = (timestamp) => {
    const date = new Date(Number(timestamp) * 1000); // convert seconds → ms
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
};

export const formatFullDateTime = (timestamp) => {
    const date = new Date(Number(timestamp) * 1000); // convert seconds → ms
    return date.toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
};

// export const getDateLabel = (timestamp) => {
//     if (!timestamp) return;
//     const messageDate = moment(timestamp * 1000).startOf('day');
//     const today = moment().startOf('day');
//     const yesterday = moment().subtract(1, 'day').startOf('day');

//     if (messageDate.isSame(today)) return 'Today';
//     if (messageDate.isSame(yesterday)) return 'Yesterday';
//     return messageDate.format('DD/MM/YYYY');
// };

export const getDateLabel = (timestamp) => {
    if (!timestamp) return;
    const messageDate = moment(timestamp * 1000).startOf('day');

    const diffDays = moment().diff(messageDate, 'days');
    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return messageDate.format('dddd');

    return messageDate.format('DD/MM/YYYY');
};

export function parseVCard(vcard) {
    const nameMatch = vcard.match(/FN:(.+)/);
    const telMatch = vcard.match(/TEL.*?waid=(\d+):(.+)/);

    const name = nameMatch ? nameMatch[1].trim() : 'Unknown';
    const phone = telMatch ? telMatch[1] : 'Unknown';

    return { name, phone };
}

export const generatePageNumbers = (table) => {
    const totalPages = table.getPageCount();
    const currentPage = table.getState().pagination.pageIndex + 1;
    const pageNumbers = [];

    if (totalPages <= 3) {
        for (let i = 1; i <= totalPages; i++) {
            pageNumbers.push(i);
        }
    } else {
        if (currentPage <= 3) {
            pageNumbers.push(1, 2, 3, '...', totalPages)
        } else if (currentPage > 3 && currentPage < totalPages - 2) {
            pageNumbers.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
        } else {
            pageNumbers.push(1, '...', totalPages - 2, totalPages - 1, totalPages);
        }
    }

    return pageNumbers;
}

export const redirectInNewTab = (path) => {
    const url = `${window.location.origin}${path}`;
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export const formatWhatsAppMessage = (message, fileName) => {
    if (!message) return null;

    // Escape HTML entities if needed
    let escaped = message
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");

    // Convert *text* to <strong>text</strong>
    escaped = escaped.replace(/\*(.*?)\*/g, '<strong>$1</strong>');
    escaped = escaped.replace(/^- /gm, '• ');

    // Convert URLs to clickable links
    escaped = escaped.replace(
        /(https?:\/\/[^\s]+)/g,
        '<a href="$1" class="message-link" target="_blank" rel="noopener noreferrer">$1</a>'
    );

    // Convert newlines to <br>
    return escaped.replace(/\n/g, '<br />');
}

export const formatedDateAndTime = (time) => {
    if (!time) return null;
    return moment(time).format('DD MMM YYYY, h:mm A');
}

export const getDisplayName = (contact) => {
    if (!contact) return '';
    const { name, push_name, is_group } = contact;

    return is_group ? name : name?.startsWith('+') ? isNaN(push_name) ? push_name : '' : name;
};

export const formatePhoneNumber = (jid) => {
    if (!jid) return;
    const lidOrGroup = jid.endsWith('@lid') || jid.endsWith('@g.us');
    const number = jid.split('@')[0];

    if (lidOrGroup) return number;

    const phoneNumber = number?.startsWith('+') ? number : `+${number}`
    const parsed = parsePhoneNumberFromString(phoneNumber);

    if (!parsed) return phoneNumber;

    return parsed.formatInternational()
};

export const messageLabel = (message) => {
    if (!message) return 'No message';

    if (message?.latest_message) {
        const text = formatWhatsAppMessage(message.latest_message)
        return text.length > 40 ? text.slice(0, 40) + "..." : text;
        // return message?.latest_message?.length > 40 ? message.latest_message.slice(0, 40) + "..." : message.latest_message
    } else if (message?.type === "videoMessage") {
        return 'Video';
    } else if (message?.type === "imageMessage") {
        return 'Photo';
    } else if (message?.type === "audioMessage") {
        return 'Audio';
    } else if (message?.type === "documentMessage") {
        return 'Document';
    }
};

export const filterContacts = (contacts, searchTerm) => {
    const lowerSearch = searchTerm.toLowerCase();

    return contacts.filter(contact => {
        const waId = contact.wa_id?.replace(/@s?\.whatsapp\.net$/, '') || '';
        return (
            (contact.name && contact.name.toLowerCase().includes(lowerSearch)) ||
            (contact.push_name && contact.push_name.toLowerCase().includes(lowerSearch)) ||
            waId.includes(lowerSearch)
        );
    });
};

export const formatContactName = (name, pushName) => {
    const startsWithNumber = (value) => /^\d/.test(value);

    if (!startsWithNumber(name)) return name;

    if (pushName) {
        return startsWithNumber(pushName)
            ? formatePhoneNumber(pushName)
            : pushName;
    }

    return formatePhoneNumber(name);
};

export const utcToLocalTime = (utcTime) => {
    const today = new Date().toISOString().split("T")[0];
    const date = new Date(`${today}T${utcTime}Z`);

    return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    });
};

export const encryptUrlSafe = (text) => {
    if (!text) return;

    try {
        return btoa(encrypt(text)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    } catch (error) {
        return null;
    }
}

export const decryptUrlSafe = (text) => {
    if (!text) return;
    try {
        let base64 = text.replace(/-/g, '+').replace(/_/g, '/');

        const pad = base64.length % 4;
        if (pad) {
            base64 += '='.repeat(4 - pad);
        }

        return decrypt(atob(base64));
    } catch (error) {
        return null;
    }
}

export const whatsappMediaType = {
    'stickerMessage': 'sticker',
    'imageMessage': 'image',
    'videoMessage': 'video',
    'audioMessage': 'audio',
    'documentMessage': 'document',
}
